import React from 'react';
import { connect } from "react-redux";

import SelectField from '../common/form/SelectField';
import { LOADING_STATUES } from "../constants/constants";
import { selectLanguage } from '../../redux/actions/languageActions';
import translations from "../../config/translation/login_translations.json"

import landnotification_logo from '../../img/trimin_landnotification_verysmall.png';

const mapStateToProps = state => {
	return {
		countyName: state.countyConfigCommonReducer.countyName,
		appTitle: state.countyConfigCommonReducer.appTitle,
		language: state.languageReducer ? state.languageReducer : 'ENGLISH',
		languages: state.countyConfigLanguagesReducer  
	};
}

const matchDispatchToProps = (dispatch) => {
  return {
	selectLanguage: (language, callback) => dispatch(selectLanguage(language, callback))
  }
}

class LoginTop extends React.Component {

    state = {
		loadingStatus: ''
	};

	handleTriminClick = (event) => {
		event.preventDefault();
		window.open("https://www.trimingov.com/");
	};

	handleLanguageChange = (event) => {
		event.preventDefault();

		if (this.showLoading() === true) {
			this.props.selectLanguage(event.target.value, this.hideLoading); //ck add callback
		}
	}

	showLoading = () => {
		if (this.state.loadingStatus === "") {
			this.setState({
				loadingStatus: LOADING_STATUES.LOADING
			})
			return true;
		}
		return false;
	}

	hideLoading = (loadingStatus) => {
		if (loadingStatus === 'ERROR') {
			this.setState({
				loadingStatus: ""
			})
		} else {
			this.setState({
				loadingStatus: ""
			})
		}
	}

	render() {
		const languageOptions = [
		{ code: "ENGLISH", description: "English" },
		{ code: "SPANISH", description: "español" }];

		return (
			<header className="container-fluid" style={{borderBottom: '3px solid black'}} >
				<table>
					<tbody>
						<tr>
							<td valign="bottom" width="90%">
								<table align="left">
									<tbody>
										<tr>
											<td>
												<span style={{ color: '#003E7F', fontSize: 36, fontVariant: 'small-caps', fontWeight: 'bold' }}>{this.props.countyName} {this.props.appTitle}</span>
											</td>
										</tr>
										<tr>
											<td>
												<span style={{ fontSize: 20, fontWeight: 500, marginTop: 50 }}>&nbsp;powered by&nbsp;</span>
												<img border="0" src={landnotification_logo} role='link' alt="Trimin Systems Government Division home" style={{ paddingBottom: 15, cursor: "pointer" }} onClick={ this.handleTriminClick} />
											</td>
										</tr>
									</tbody>
								</table>
							</td>
							{
								this.props.languages.languages === true &&
								<td valign="center" width="10%" >
									<SelectField formGroup={{ id: 'language', layout: 'horizontal', label: translations[this.props.language].language, labelFor:'language', fieldType: 'select', value: this.props.language, options: languageOptions }} style={{marginBottom : 2}} onChange={this.handleLanguageChange} />
								</td>
							}
						</tr>
					</tbody>
				</table>
			</header>
		)
	}
}

export default connect(mapStateToProps, matchDispatchToProps)(LoginTop);